<div
  class="playerStatsMainContainer"
>
  <app-cross-close-button>
  </app-cross-close-button>
  <div *ngIf="!getPlayerVideosOpened()">
    <div>
      <h1>{{getPlayerFullName()}}</h1>
    </div>
    <app-player-summary
      [playerSummaryObject]="playerSummaryList"
      [playerPhoto]="playerPhoto"
      (outputClickOnVideos)="setPlayerVideosOpened()"
    >
    </app-player-summary>
    <app-player-stats-table-of-details
      [tableContent]="tableOfDetails"
    >
    </app-player-stats-table-of-details>
  </div>
  <div *ngIf="getPlayerVideosOpened()">
    <app-player-video-modal
      [playerData]="playerSummaryList"
      (outputClickOnBack)="setPlayerVideosOpened()"
    >
    </app-player-video-modal>
  </div>
</div>
